export default {
  props: {
    /**
     * The field name.
     */
    name: {
      type: String,
      required: true,
    },

    /**
     * The field value.
     */
    value: {
      type: String,
      required: false,
      default: '',
    },

    /**
     * The field value.
     */
    href: {
      type: String,
      required: true,
      default: '#',
    },

    /**
     * The field value.
     */
    target: {
      type: String,
      required: false,
      default: '_self',
    },

    fieldClass: {
      type: String,
      required: false,
      default: 'link-in-table',
    },

    linkIcon: {
      type: String,
      required: false,
      default: 'fa fa-link',
    },

    fieldDisable: {
      type: Boolean,
      required: false,
      default: false,
    }
    
  },

  /**
   * This function will be called to render the HTML.
   *
   * @param  {Function} h Mandatory for vue to render JSX.
   */
  // eslint-disable-next-line
  render (h) {
    if (this.fieldDisable === true) return (<p style="cursor:context-menu;" class={this.fieldClass}><i class={this.linkIcon}></i> {this.value}</p>);
    else return (<a style="cursor:cursor;" href={this.href} target={this.target} class={this.fieldClass}><i class={this.linkIcon}></i> {this.value}</a>);
  },
};



// WEBPACK FOOTER //
// ./src/app/components/form/link/link.jsx